export async function requireExchangeValues (context) {
   try {
      let res = await axios.get('api/v1/forms/getFormCollections?with[]=banxicoUdis&with[]=banxicoMxnUsdExchange&with[]=banxicoFundTiie');
      context.commit('setUdis', res.data.banxicoUdis.udis);
      context.commit('setUsdExchange', res.data.banxicoMxnUsdExchange);
      context.commit('setFundTiie', res.data.banxicoFundTiie.tiie_value);
      context.commit('setFundTiieState', res.data.banxicoFundTiie.fund_tiie_state);
      context.commit('setRgInterestBase', res.data.banxicoFundTiie.rg_interest_base);
      context.commit('setTiiePercentagePoints', res.data.banxicoFundTiie.percentage_points);
      context.commit('setTiieQueryDate', res.data.banxicoFundTiie.query_date);
      context.commit('setData', res.data.banxicoFundTiie);
  } catch (error) {
      console.error(error);
  }
}
